module.exports = __webpack_public_path__ + "img/doctorImageMobile.a653e1fd.png";